"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CopyButton;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clipboardMin = _interopRequireDefault(require("clipboard/dist/clipboard.min.js"));

var _icon = _interopRequireDefault(require("../icon"));

var _popover = _interopRequireDefault(require("../popover"));

var _tooltip = _interopRequireDefault(require("../tooltip"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var FEEDBACK_TIME = 800;

/**
 * A button that, when clicked, copies the designated text to the clipboard.
 *
 * The static function `CopyButton.isCopySupported` returns a boolean
 * indicating whether the current browser will support automatic copying.
 * If it does not, you might want to hide your copy button and make sure
 * the user is able to manually select and copy the text.
 */
function CopyButton(_ref) {
  var text = _ref.text,
      onCopy = _ref.onCopy,
      _ref$block = _ref.block,
      block = _ref$block === void 0 ? false : _ref$block,
      focusTrapPaused = _ref.focusTrapPaused,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? 'btn btn--xs py3 px3 round' : _ref$className,
      children = _ref.children,
      _ref$tooltipColoring = _ref.tooltipColoring,
      tooltipColoring = _ref$tooltipColoring === void 0 ? 'light' : _ref$tooltipColoring,
      _ref$tooltipTextSize = _ref.tooltipTextSize,
      tooltipTextSize = _ref$tooltipTextSize === void 0 ? 's' : _ref$tooltipTextSize,
      passthroughProps = _ref.passthroughProps;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      clipboard = _useState2[0],
      setClipboard = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      clipboardElement = _useState4[0],
      setClipboardElement = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      showingFeedback = _useState6[0],
      setShowingFeedback = _useState6[1];

  var makeClipboard = (0, _react.useCallback)(function () {
    if (clipboardElement) {
      setClipboard(new _clipboardMin.default(clipboardElement, _objectSpread({}, !focusTrapPaused && {
        container: clipboardElement
      })));
    }
  }, [focusTrapPaused, clipboardElement]);

  var reinitializeClipboard = function reinitializeClipboard() {
    if (clipboard) {
      clipboard.destroy();
      makeClipboard();
    }
  };

  (0, _react.useEffect)(function () {
    return function () {
      if (clipboard) {
        clipboard.destroy();
      }
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  (0, _react.useEffect)(function () {
    // initialize clipboard once ref is set
    if (clipboardElement && !clipboard) {
      makeClipboard();
    }
  }, [clipboardElement, clipboard, makeClipboard]);
  (0, _react.useEffect)(function () {
    var timer;

    if (showingFeedback) {
      timer = setTimeout(function () {
        setShowingFeedback(false);
      }, FEEDBACK_TIME);
    }

    return function () {
      return clearTimeout(timer);
    };
  }, [showingFeedback]);

  var handleCopyButtonClick = function handleCopyButtonClick() {
    // Clipboard.js attaches its own click handlers for copying
    if (onCopy) {
      onCopy(text);
    } // Show feedback


    setShowingFeedback(true);
    reinitializeClipboard();
  };

  var iconName = showingFeedback ? 'check' : 'clipboard';
  var buttonClasses = (0, _classnames.default)(className, {
    block: block
  });
  var body = children ? children : /*#__PURE__*/_react.default.createElement("button", _extends({
    type: "button",
    className: buttonClasses
  }, passthroughProps), /*#__PURE__*/_react.default.createElement(_icon.default, {
    name: iconName
  }));
  var popoverContent = 'Copied!';

  if (tooltipTextSize !== 'none') {
    popoverContent = /*#__PURE__*/_react.default.createElement("div", {
      className: "txt-".concat(tooltipTextSize)
    }, popoverContent);
  } // data-clipboard-text and the container ref are used by clipboard.js
  // to copy text. Note that this wont have as nice a failure mode.


  return /*#__PURE__*/_react.default.createElement("div", {
    role: "button",
    "aria-label": "Copy",
    "data-testid": "copy-button",
    ref: function ref(_ref2) {
      return setClipboardElement(_ref2);
    },
    "data-clipboard-text": text,
    onClick: handleCopyButtonClick
  }, /*#__PURE__*/_react.default.createElement(_popover.default, {
    content: popoverContent,
    active: showingFeedback,
    coloring: tooltipColoring,
    placement: "top",
    alignment: "center",
    hideWhenAnchorIsOffscreen: true,
    padding: "small"
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_tooltip.default, {
    disabled: showingFeedback,
    coloring: tooltipColoring,
    textSize: tooltipTextSize,
    content: "Copy"
  }, body))));
}

CopyButton.propTypes = {
  /**
   * The text that will be copied when the button is clicked.
   */
  text: _propTypes.default.string.isRequired,

  /**
   * Invoked when the button is clicked.
   * Passed one argument: the `text` prop.
   */
  onCopy: _propTypes.default.func,

  /**
   * If `true`, the element will be `block` displayed instead of `inline-block`.
   *
   * This is sometimes necessary to get your pixel-perfect layout, if you don't
   * want the extra line-height that wraps inline elements. Typically, you
   * should only set `block` to `true` if the parent element is controlling
   * width (in a layout that uses flexbox, absolute positioning, or floats).
   */
  block: _propTypes.default.bool,

  /**
   * If `true`, this will allow interaction with elements outside of the
   * modal container. You normally don't want to set this, but it can be
   * useful for nesting different components that are displaced to other
   * parts of the DOM.
   */
  focusTrapPaused: _propTypes.default.bool,

  /**
   * The `className` prop of the `<button>`.
   */
  className: _propTypes.default.string,

  /**
   * An object of props that you want to pass through to the `<button>`.
   */
  passthroughProps: _propTypes.default.object,

  /**
   * Either `'light'` or `'dark'`. This value is passed as the `coloring` prop found in Tooltip and Popover.
   */
  tooltipColoring: _propTypes.default.oneOf(['light', 'dark']),

  /**
   * `'xs'` (extra small), `'s'` (small), or `'none'` (no size class).
   */
  tooltipTextSize: _propTypes.default.oneOf(['xs', 's', 'none']),

  /** Optional content to represent the button. */
  children: _propTypes.default.node
};

CopyButton.isCopySupported = function () {
  return typeof window === 'undefined' ? false : _clipboardMin.default.isSupported();
};